import React from 'react';
import { Input } from './fields/Input';
import { Textarea } from './fields/Textarea';
import { Address } from './fields/Address';
import { Date } from './fields/Date';
import { File } from './fields/File';
import { Select } from './fields/Select';
import { Check } from './fields/Check';
import { Subheading } from './fields/Subheading';
import { Radio } from './fields/Radio';
import { Text } from './fields/Text';
import { Submit } from './fields/Submit';
import { Content } from './fields/Content';
import { InvisibleRecaptcha } from './fields/InvisibleRecaptcha';
export var FieldType;
(function (FieldType) {
    FieldType["ADDRESS"] = "address";
    FieldType["CHECK"] = "check";
    FieldType["DATE"] = "date";
    FieldType["FILE"] = "file";
    FieldType["INPUT"] = "input";
    FieldType["RADIO"] = "radio";
    FieldType["SELECT"] = "select";
    FieldType["SUBHEADING"] = "subheading";
    FieldType["SUBMIT"] = "submit";
    FieldType["TEXT"] = "text";
    FieldType["TEXTAREA"] = "textarea";
    FieldType["CONTENT"] = "content";
    FieldType["HIDDEN"] = "hidden";
    FieldType["INVISIBLERECAPTCHA"] = "invisiblerecaptcha";
})(FieldType || (FieldType = {}));
export const FieldSwitch = ({ field, onChange, value, submitting }) => {
    switch (field.type) {
        case FieldType.ADDRESS:
            return React.createElement(Address, { field: field, onChange: onChange, value: value });
        case FieldType.CHECK:
            return React.createElement(Check, { field: field, onChange: onChange, value: value });
        case FieldType.DATE:
            return React.createElement(Date, { field: field, onChange: onChange, value: value });
        case FieldType.FILE:
            return React.createElement(File, { field: field, onChange: onChange, value: value });
        case FieldType.INPUT:
            return React.createElement(Input, { field: field, onChange: onChange, value: value });
        case FieldType.RADIO:
            return React.createElement(Radio, { field: field, onChange: onChange, value: value });
        case FieldType.SELECT:
            return React.createElement(Select, { field: field, onChange: onChange, value: value });
        case FieldType.SUBHEADING:
            return React.createElement(Subheading, { field: field, onChange: onChange });
        case FieldType.SUBMIT:
            return React.createElement(Submit, { field: field, submitting: submitting });
        case FieldType.TEXT:
            return React.createElement(Text, { field: field, onChange: onChange });
        case FieldType.TEXTAREA:
            return React.createElement(Textarea, { field: field, onChange: onChange, value: value });
        case FieldType.CONTENT:
            return React.createElement(Content, { field: field });
        case FieldType.INVISIBLERECAPTCHA:
            return React.createElement(InvisibleRecaptcha, { field: field, submitting: submitting });
        default:
            return null;
    }
};
